<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs required">{{
          $t('bankProfile.bankName')
        }}</label>
        <input
          v-model="model.bank_name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('bank_name') }"
        />
        <div class="invalid-feedback ts-text-xs" v-if="errors.has('bank_name')">
          {{ errors.first('bank_name') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{
          $t('bankProfile.accountNumber')
        }}</label>
        <div class="ts-border ts-border-blue-300 ts-rounded ts-p-2 ts-relative">
          <span
            class="
              ts-border
              ts-rounded-full
              ts-absolute
              ts-top-0
              ts-right-0
              ts-bg-white
              ts-cursor-pointer
            "
            style="padding: 0 0.3rem; top: -10px; right: -10px"
            @click.prevent="addAccount"
          >
            <i class="fa fa-plus"></i>
          </span>
          <br />
          <div class="ts-grid ts-grid-cols-2 ts-gap-3">
            <template v-for="(a, index) in model.account_number">
              <div>
                <input
                  v-model.trim="a.account_number"
                  type="text"
                  class="form-control"
                  :placeholder="$t('bankProfile.accountNumber')"
                />
                <div
                  class="validate"
                  v-if="
                    errors.has('account_number.' + index + '.account_number')
                  "
                >
                  {{
                    errors.first('account_number.' + index + '.account_number')
                  }}
                </div>
              </div>
              <div>
                <div class="ts-flex ts-space-x-3 ts-items-center">
                  <input
                    v-model="a.account_name"
                    type="text"
                    class="form-control"
                    :placeholder="$t('bankProfile.accountName')"
                  />
                  <a href="#" class="ts-text-red-700"
										@click.prevent="remove(index)"
									><i class="fa fa-trash"></i
                  ></a>
                </div>
                <div
                  class="validate"
                  v-if="errors.has('account_number.' + index + '.account_name')"
                >
                  {{
                    errors.first('account_number.' + index + '.account_name')
                  }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('bankProfile.description') }}</label>
        <textarea
          rows="3"
          class="form-control"
          v-model.trim="model.description"
        ></textarea>
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('description')"
        >
          {{ errors.first('description') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'bankProfileForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        bank_id: 0,
        bank_name: null,
        description: null,
        account_number: [
					{
						account_number: null,
        		account_name: null,
					}
				],
      },
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('corporate/bankProfile', ['edit_data']),
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
  },
  methods: {
    addAccount() {
      this.model.account_number.push({
        account_number: null,
        account_name: null,
      })
    },
    remove(index) {
			this.model.account_number.splice(index, 1)
		},
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('corporate/bankProfile/store', this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('corporate/bankProfile/update', {
          id: this.model.bank_id,
          data: this.model,
        })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.bank_id = this.edit_data.bank_id
        this.model.bank_name = this.edit_data.bank_name
        this.model.description = this.edit_data.description
        this.model.account_number = this.edit_data.accounts.map((el) => ({
          account_number: el.account_number,
          account_name: el.account_name,
        }))
      }
    },
  },
}
</script>
